import Login from '../login/Login';
import {DivMain} from './styleLoginPage'
export default function loginPage({login}){
    // console.log('page login')
    // console.log(login)
    // console.log('saiu page login')
    const imageLogo = require('../../assets/images/logo_200_social.jpg').default;
    const imageBanner = require('../../assets/images/social52.jpeg').default;
    const imageBannerMobile = require('../../assets/images/social51.jpeg').default;
    return (<DivMain >
        <img style={{width:window.screen.width < 800? '100%' : '70%'}} src={window.screen.width < 800? imageBannerMobile :imageBanner} alt='' />
        <img src={imageLogo} alt=''/>
        <p style={{fontFamily:'Ubuntu!important',fontSize:'20px', margin:'0 0 20px 0'}} >Clique no botão abaixo para acessar ao sistema e utilizar o conteúdo</p>
        <Login login={login} txtbutton='Entrar' />
    </DivMain>)
}
